import pmRequest from "@/utils/pmRequest";

/**
 * @desc: 项目
 * @param {*} params
 * @return {*}
 */
export function getProjectListApi (params) {
  return pmRequest({
    url: "/pm/project/getProjectList",
    method: "get",
    params: params
  })
}
//
/**
 * @desc: 已归档项目列表
 * @param {*} params
 * @return {*}
 */
export function getArchivedProjectList (params) {
  return pmRequest({
    url: "/pm/project/getArchivedProjectList",
    method: "get",
    params
  });
}

/**
 * @desc: 星标项目列表 
 * @param {*} params
 * @return {*}
 */
export function getStarListApi (params) {
  return pmRequest({
    url: "/pm/project/getStarList",
    method: "get",
    params
  });
}
//
/**
 * @desc: 已回收项目列表
 * @param {*} params
 * @return {*}
 */
export function getRecycledProjectList (params) {
  return pmRequest({
    url: "/pm/project/getRecycledProjectList",
    method: "get",
    params
  });
}

export function getProjectDetailApi (params) {
  return pmRequest({
    url: "/pm/project/getProjectDetail",
    method: "get",
    params
  });
}


export function getRecentProjectApi (params) {
  return pmRequest({
    url: "/pm/project/getRecentVisitProject",
    method: "get",
    params
  });
}

export function createProjectApi (data) {
  return pmRequest({
    url: "/pm/project/createProject",
    method: "post",
    data
  });
}

export function editProjectApi (data) {
  return pmRequest({
    url: "/pm/project/editProject",
    method: "post",
    data
  });
}

export function setProjectGroupApi (data) {
  return pmRequest({
    url: "/pm/project/addgroup",
    method: "post",
    data
  });
}

export function starProjectApi (data) {
  return pmRequest({
    url: "/pm/project/star",
    method: "post",
    data
  });
}

export function archiveProjectApi (data) {
  return pmRequest({
    url: "/pm/project/archive",
    method: "post",
    data
  });
}

export function recycleProjectApi (data) {
  return pmRequest({
    url: "/pm/project/recycle",
    method: "post",
    data
  });
}

export function removeProjectApi (data) {
  return pmRequest({
    url: "/pm/project/deleteProject",
    method: "post",
    data
  });
}

export function transferProjectApi (data) {
  return pmRequest({
    url: "/pm/project/transfer",
    method: "post",
    data
  });
}